var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#f7df1e",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 212.980469 676.886719 L 274.964844 639.394531 C 286.921875 660.59375 297.800781 678.53125 323.90625 678.53125 C 348.902344 678.53125 364.691406 668.722656 364.691406 630.691406 L 364.691406 371.871094 L 440.785156 371.871094 L 440.785156 631.769531 C 440.785156 710.585938 394.589844 746.496094 327.164062 746.496094 C 266.265625 746.496094 230.917969 714.953125 212.976562 676.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 482.140625 668.726562 L 544.125 632.84375 C 560.449219 659.484375 581.648438 679.070312 619.144531 679.070312 C 650.6875 679.070312 670.8125 663.3125 670.8125 641.546875 C 670.8125 615.441406 650.152344 606.203125 615.347656 590.984375 L 596.332031 582.820312 C 541.402344 559.4375 504.984375 530.105469 504.984375 468.089844 C 504.984375 411.011719 548.457031 367.507812 616.453125 367.507812 C 664.832031 367.507812 699.636719 384.371094 724.632812 428.414062 L 665.371094 466.476562 C 652.335938 443.09375 638.191406 433.855469 616.453125 433.855469 C 594.148438 433.855469 580.003906 448 580.003906 466.476562 C 580.003906 489.324219 594.148438 498.5625 626.769531 512.703125 L 645.785156 520.835938 C 710.488281 548.585938 746.941406 576.839844 746.941406 640.46875 C 746.941406 708.972656 693.121094 746.496094 620.789062 746.496094 C 550.105469 746.496094 504.445312 712.769531 482.140625 668.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.64d388f78fd09f9b05547336fc7617e5.svg";
export { ForwardRef as ReactComponent };